import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cart_items')) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('cart_items', JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1, variant = null) => {
    setItems(prev => {
      const cartKey = variant ? `${product.id}_${variant.name}` : product.id;
      const existing = prev.find(i => i.cart_key === cartKey);
      if (existing) {
        return prev.map(i => i.cart_key === cartKey ? { ...i, quantity: i.quantity + quantity } : i);
      }
      const price = variant ? variant.price : (product.sale_price || product.price);
      return [...prev, {
        cart_key: cartKey,
        product_id: product.id,
        name: product.name,
        variant_name: variant?.name || null,
        price,
        quantity,
        image: product.images?.[0] || '',
        age_restricted: product.age_restricted
      }];
    });
  };

  const removeItem = (cartKey) => {
    setItems(prev => prev.filter(i => i.cart_key !== cartKey));
  };

  const updateQuantity = (cartKey, quantity) => {
    if (quantity <= 0) return removeItem(cartKey);
    setItems(prev => prev.map(i => i.cart_key === cartKey ? { ...i, quantity } : i));
  };

  const clearCart = () => setItems([]);

  const itemCount = items.reduce((sum, i) => sum + i.quantity, 0);
  const subtotal = items.reduce((sum, i) => sum + i.price * i.quantity, 0);
  const hasAlcohol = items.some(i => i.age_restricted);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQuantity, clearCart, itemCount, subtotal, hasAlcohol }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
